import { useEffect, useState } from 'react'
import { HistoryView } from '../../views'
import { UsageService, LocalStorageService } from '../../../services'
import moment from 'moment'

const HistoryAction = () => {
  const url = process.env.REACT_APP_ETICKET_API
  const usageService = new UsageService(url)
  const localStorageService = new LocalStorageService()
  const token = localStorageService.getLocalStorageItem('token')?.accessToken
  const chatbotUrl = process.env.REACT_APP_CHATBOT_URL
  
  const [dataConversations, setDataConversations] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingChangePage, setIsLoadingChangePage] = useState(true)
  const [date, setDate] = useState(parseInt(moment().format('YYYYMM')))

  const monthYearOptions = Array.from({ length: 12 }, (_, i) => {
      const monthDate = moment().subtract(i, 'months')
      const value = parseInt(monthDate.format('YYYYMM'))
      return {
          value,
          text: monthDate.format('MMMM YYYY')
      }
  }).reverse()

  const handleChangeDate = (event) => {
      setDate(event.target.value.value)
  }

  useEffect(() => {
    handleGetPaginatedConversation(1, 10)
  }, [])

  useEffect(() => {
    handleGetPaginatedConversation(1, 10)
  }, [date])
  
  /**
   * @description method to get paginated conversation
   * @param page page number
   * @param limit number of registers by page
   */
  const handleGetPaginatedConversation = async (page, limit, sort = null) => {
    try {
      setIsLoadingChangePage(true)
      const monthNumber = date % 100
      const yearNumber = Math.floor(date / 100)

      const response = await usageService.getConversationsByDateAndPageLimit(yearNumber, monthNumber, token, null, page, limit, sort)
      setDataConversations(response)
      setIsLoadingChangePage(false)
      isLoading && setIsLoading(false)
    } catch (error) {
      console.error(`An error has ocurred in usageAction: ${error}`)
      setIsLoadingChangePage(false)
    }
  }

  return (
    <HistoryView
      isLoading={isLoading}
      isLoadingChangePage={isLoadingChangePage}
      dataConversations={dataConversations}
      date={date}
      handleChangeDate={handleChangeDate}
      monthYearOptions={monthYearOptions}
      chatbotUrl={chatbotUrl}
      handleGetPaginatedConversation={handleGetPaginatedConversation}
    />
  )
}

export { HistoryAction as default }